export default "__VITE_ASSET__LEyzWuua__"